export default "__VITE_ASSET__DpSr8nvM__"